(function () {
  var TZ = 'Australia/Sydney';

  function sydneyDateParts() {
    var parts = new Intl.DateTimeFormat('en-AU', {
      timeZone: TZ,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      weekday: 'short',
      hour: '2-digit',
      hour12: false
    }).formatToParts(new Date());

    var map = {};
    parts.forEach(function (p) {
      if (p.type !== 'literal') map[p.type] = p.value;
    });
    return map;
  }

  function sydneyToday() {
    var p = sydneyDateParts();
    return new Date(Number(p.year), Number(p.month) - 1, Number(p.day));
  }

  function isWeekend(date) {
    var d = date.getDay();
    return d === 0 || d === 6;
  }

  function addBusinessDays(start, count) {
    var date = new Date(start.getTime());
    var added = 0;
    while (added < count) {
      date.setDate(date.getDate() + 1);
      if (!isWeekend(date)) added++;
    }
    return date;
  }

  function formatLabel(date) {
    return date.toLocaleDateString('en-AU', {
      timeZone: TZ,
      weekday: 'long',
      day: 'numeric',
      month: 'long'
    });
  }

  function toIso(date) {
    var y = date.getFullYear();
    var m = String(date.getMonth() + 1).padStart(2, '0');
    var d = String(date.getDate()).padStart(2, '0');
    return y + '-' + m + '-' + d;
  }

  function parseIso(raw) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(raw || '');
    return m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : null;
  }

  function readDays(el, attr, fallback) {
    var raw = el.getAttribute(attr);
    if (raw === null || raw === '') return fallback;
    var n = Number(raw);
    return isNaN(n) ? fallback : n;
  }

  function initEstimate(el) {
    if (!el || el.getAttribute('data-initialized') === 'true') return;

    var processingMin = readDays(el, 'data-processing-min', 0);
    var processingMax = readDays(el, 'data-processing-max', 1);
    var shippingMin = readDays(el, 'data-shipping-min', 1);
    var shippingMax = readDays(el, 'data-shipping-max', 3);
    if (processingMax < processingMin) processingMax = processingMin;
    if (shippingMax < shippingMin) shippingMax = shippingMin;

    var today = sydneyToday();
    var dispatchEarliest = addBusinessDays(today, processingMin);
    var dispatchLatest = addBusinessDays(today, processingMax);

    // Pre-order / holiday mode (Theme settings > Shipping mode): count transit from the
    // configured dispatch date instead of today, until the return-to-normal date.
    var delayed = el.hasAttribute('data-dispatch-delayed');
    var until = el.getAttribute('data-dispatch-until') || '';
    if (delayed && until && toIso(today) >= until) delayed = false;
    if (delayed) {
      var mainEl = el.querySelector('.po-delivery-estimate__main');
      var dispatchDate = parseIso(el.getAttribute('data-dispatch-date'));
      if (!dispatchDate || el.getAttribute('data-dispatch-estimate') !== '1') {
        if (mainEl) mainEl.hidden = true;
        el.hidden = false;
        el.setAttribute('data-initialized', 'true');
        return;
      }
      if (dispatchDate < today) dispatchDate = today;
      while (isWeekend(dispatchDate)) dispatchDate.setDate(dispatchDate.getDate() + 1);
      dispatchEarliest = dispatchDate;
      dispatchLatest = dispatchDate;
      var afterEl = el.querySelector('.po-delivery-estimate__after');
      if (afterEl) afterEl.hidden = false;
    }

    var arriveEarliest = addBusinessDays(dispatchEarliest, shippingMin);
    var arriveLatest = addBusinessDays(dispatchLatest, shippingMax);

    var fromEl = el.querySelector('.po-delivery-estimate__from');
    var toEl = el.querySelector('.po-delivery-estimate__to');

    if (fromEl) {
      fromEl.textContent = formatLabel(arriveEarliest);
      fromEl.setAttribute('datetime', toIso(arriveEarliest));
    }
    if (toEl) {
      toEl.textContent = formatLabel(arriveLatest);
      toEl.setAttribute('datetime', toIso(arriveLatest));
    }

    el.hidden = false;
    el.setAttribute('data-initialized', 'true');
  }

  function initAll() {
    document.querySelectorAll('[data-po-delivery-estimate]').forEach(initEstimate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
